export const GUID_VIDE = '00000000-0000-0000-0000-000000000000';
export const INFINITE_DAY = new Date(2700, 12, 1);
export const MODE_CALCUL_MANUEL = 'Manuel';
